import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { Currency } from 'modules/expenses/hooks/useExpensesListPage'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

type Props = BaseFilterProps & {
  currencies: Currency[]
}
const reimbursableCurrencyFilter = ({
  currencies,
  expensesContext,
}: Props): DataTableFilter<ExpensesExpensableFilter> => {
  const options = [...currencies]
    .sort((cur1, cur2) => (cur1!.priority > cur2!.priority ? 1 : -1))
    .map((currency) => ({
      label: `${currency?.isoCode} - ${currency?.name}`,
      value: currency?.isoCode as string,
    }))

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    onUpdateValue: () => {
      trackFilters('reimbursable_currency', expensesContext)
    },
    identifier: 'expensesList.reimbursableCurrencyFilter',
    path: 'reimbursableCurrency',
    title: i18n.t('expenses_v2.forms.fields.reimbursable_currency.label'),
  }
}

export default reimbursableCurrencyFilter
